import { render, staticRenderFns } from "./TabCombination.vue?vue&type=template&id=1fbdca9c&scoped=true&"
import script from "./TabCombination.vue?vue&type=script&lang=js&"
export * from "./TabCombination.vue?vue&type=script&lang=js&"
import style0 from "./TabCombination.vue?vue&type=style&index=0&id=1fbdca9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbdca9c",
  null
  
)

export default component.exports